
import { defineComponent } from "vue";
import AppContent from "@/components/layout/AppContent.vue";

export default defineComponent({
  name: "Terms of Service",
  components: { AppContent },
});
